import axios from "axios";

import { EXPIRES, TOKEN } from "../token-service/token.service";
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/`;

export const axiosInstance = axios.create({ baseURL: BASE_URL });

axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem(TOKEN);
  const tokenExpiration = localStorage.getItem(EXPIRES);
  const valid = !!(tokenExpiration && tokenExpiration > new Date().getTime());

  if (token && valid && config?.headers) {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }
});
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response.status === 401) {
      // localStorage.clear();
      // location.reload();
    }
    return error;
  }
);
